const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="mt-25 border-t border-h-gold pt-6 pb-6">
      <p className="text-center pb-2">
        <a
          href="#/about"
          className="text-h-gold uppercase tracking-[0.15em] text-sm hover:opacity-70"
        >
          About Us
        </a>
      </p>
      <p className="font-glacial text-h-gold text-center">
        H Projects © {currentYear}
      </p>
    </footer>
  );
};

export default Footer;
